import { BrainCircuit, Layers } from 'lucide-react'
import type { AppModule } from '@/shared/modules'

export const MODEL_REGISTRY_MODULE_ID = 'model-registry'

export const modelRegistryModule: AppModule = {
  id: MODEL_REGISTRY_MODULE_ID,
  surface: 'app',
  permissions: ['model-registry:view'],
  nav: [
    {
      to: '/app/model-registry',
      labelKey: 'nav.modelRegistry',
      icon: BrainCircuit,
      // Same group as Model Training; registered before it, so listed above it (design D1).
      group: { id: 'model-management', labelKey: 'nav.modelManagement', icon: Layers },
    },
  ],
}
